import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommercialOutOfJurisdictionRegistrationService } from '@max/commercialpermitting/services/commercial-out-of-Jurisdiction-registration.service';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';
import { SharedModule } from '@max/shared/shared.module';
import { OutOfJurisdictionRegistrationModalComponent } from './out-of-jurisdiction-registration-modal.component';

@NgModule({
    declarations: [
        OutOfJurisdictionRegistrationModalComponent
    ],
    providers: [
        CommercialOutOfJurisdictionRegistrationService
    ],
    imports: [
        SharedModule,
        CommonModule,
        SharedPipesModule,
        ReactiveFormsModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'})
    ],
    exports: [
        OutOfJurisdictionRegistrationModalComponent
    ]
})
export class OutOfJurisdictionRegistrationModalModule {
}
